(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.initPieCharts = {
    attach: function (context, settings) {
      once('cdss-blocks-pie-chart', '.cdss-blocks-pie-chart', context).forEach(initPieCharts);
    }
  }

  function initPieCharts(el) {
    const chartData = $(el).attr('data-chart');
    const pieChartType = $(el).attr('data-pie_chart_type');
    let startAngle = $(el).attr('data-chart_start_angle');

    startAngle = Number(startAngle);
    console.log(typeof startAngle);
    

    if (chartData) {
      try {
        const data = JSON.parse(chartData);
        drawPieChart(el, data, pieChartType, startAngle);
      } catch (e) {
        console.error("Invalid JSON data:", e);
      }
    }
  }

  function drawPieChart(el, data, pieChartType, startAngle) {
    Highcharts.setOptions({
      lang: {
          accessibility: {
              chartContainerLabel: "{title}Highcharts interactive enrollment chart"
      }}})
    Highcharts.chart(el, {
      chart: {
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      exporting: {
        enabled: false 
      },
      series: [{
        type: 'pie',
        name: data.seriesName || 'Value',
        colorByPoint: true,
        data: data.series || []
      }],
      tooltip: {
        enabled: false,
        formatter: function() {

          if (this.point.name == 'null' || this.point.name == 'Slice') {
            return false; 
          }
          return `<b>${this.point.percentage.toFixed(1)}%</b>`;
        }
      },
      plotOptions: {
        pie: {
          shadow: false,
          allowPointSelect: false,
          cursor: 'pointer',
          borderWidth: 0,
          startAngle: startAngle,
          size: '250', // Set a fixed size for the pie chart (e.g., 200px diameter)
          dataLabels: {
            alignTo: 'plotEdges',
            enabled: true,
            distance: 20, // Adjust distance if needed to keep labels outside
            useHTML: false,
            formatter: function() {

              let valueSuffix = null;
              if(pieChartType == 'percentage'){
                valueSuffix = '%';
              }

              return `<div class="item-val">${this.y + valueSuffix}</div><br/><div class="item-label">${this.point.name}</div>`;
            },
            style: {
              // width: '160px',
              color: '#000',
              fontSize: '14px',
              whiteSpace:  'normal'
            },
            connectorColor: 'silver'
          }
        }
      },
      // responsive: {
      //   rules: [{
      //     condition: {
      //       maxWidth: 767
      //     },
      //     chartOptions: {
      //       plotOptions: {
      //         pie: {
      //           size: '20%', // Adjust pie size for smaller screens,
      //           showInLegend: false, // Shows each pie slice in the legend
      //           dataLabels: {
      //             enabled: true,
      //             distance: 10, // Adjust distance if needed to keep labels outside
      //             useHTML: false,
      //           }
      //         }
      //       },
      //       legend: {
      //         enabled: true, 
      //         layout: 'vertical', 
      //         align: 'center',
      //         verticalAlign: 'bottom'
      //       }
      //     }
      //   }, {
      //     condition: {
      //       minWidth: 768 // Hide legend on screens larger than 600px
      //     },
      //     chartOptions: {
      //       legend: {
      //         enabled: false // Disable legend on larger screens
      //       }
      //     }
      //   }]
      // }
    });
  }

})(jQuery, Drupal, drupalSettings);
